var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgLighting = function SvgLighting(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.166 1.75a.751.751 0 0 1 .67 1.085L12.88 6.75h2.954a.75.75 0 0 1 .53 1.28l-10 10A.75.75 0 0 1 5.11 17.3l1.819-6.549H4.166a.751.751 0 0 1-.685-1.054l3.333-7.5.052-.097a.75.75 0 0 1 .633-.35h6.667ZM5.32 9.25h2.596a.751.751 0 0 1 .722.951l-1.32 4.75 6.703-6.7h-2.355a.751.751 0 0 1-.67-1.086l1.957-3.915H7.986l-2.666 6Z",
    fill: "#fff",
    fillOpacity: 0.85
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLighting);
export default ForwardRef;